import { render, staticRenderFns } from "./HearingDetailModal.vue?vue&type=template&id=95821904&scoped=true"
import script from "./HearingDetailModal.vue?vue&type=script&lang=js"
export * from "./HearingDetailModal.vue?vue&type=script&lang=js"
import style0 from "./HearingDetailModal.vue?vue&type=style&index=0&id=95821904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95821904",
  null
  
)

export default component.exports